// removed by extract-text-webpack-plugin
module.exports = {"header":"ModalHeader__header___spynG","close-button":"ModalHeader__close-button___3YsWf"};